import React from 'react';
import { ImagePlusIcon } from 'lucide-react';
type PhotoPlaceholderProps = {
  label: string;
  className?: string;
};

/** Empty photo slot — shown until a real client photo is uploaded */
export function PhotoPlaceholder({
  label,
  className = ''
}: PhotoPlaceholderProps) {
  return <div className={`flex flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-mauve/25 bg-cream text-center ${className}`} data-id="element-361" data-mp="3clxrz86tnh3f">
      <ImagePlusIcon className="h-8 w-8 text-mauve/50" aria-hidden="true" data-id="element-362" data-mp="2yoiy9r9jcn5n" />
      <span className="text-xs font-medium uppercase tracking-wider2 text-mauve/70" data-id="element-363" data-mp="33n401v4frew7">{label}</span>
    </div>;
}